import React, { useEffect, useRef, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Gallery.css';

// Import all images
import img1 from '../assets/pictures/1.jpg';
import img2 from '../assets/pictures/2.jpg';
import img3 from '../assets/pictures/3.jpg';
import img4 from '../assets/pictures/4.jpg';
import img6 from '../assets/pictures/6.jpg';
import img7 from '../assets/pictures/7.jpg';
import img8 from '../assets/pictures/8.jpg';
import img9 from '../assets/pictures/9.jpg';

const galleryImages = [
  { src: img1, alt: 'Maya\'s Flavours Creation 1' },
  { src: img2, alt: 'Maya\'s Flavours Creation 2' },
  { src: img3, alt: 'Maya\'s Flavours Creation 3' },
  { src: img4, alt: 'Maya\'s Flavours Creation 4' },
  { src: img6, alt: 'Maya\'s Flavours Creation 5' },
  { src: img7, alt: 'Maya\'s Flavours Creation 6' },
  { src: img8, alt: 'Maya\'s Flavours Creation 7' },
  { src: img9, alt: 'Maya\'s Flavours Creation 8' },
];

function Gallery() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="gallery-section" ref={sectionRef}>
      <div className="gallery-container">
        <div className={`gallery-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">{t('gallery.title')}</h2>
          <p className="section-subtitle">{t('gallery.subtitle')}</p>
        </div>

        <div className={`gallery-grid ${isVisible ? 'visible' : ''}`}>
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="gallery-item"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => openLightbox(image)}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
              <div className="gallery-item-overlay">
                <span className="view-icon">👁</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <FaArrowLeft />
              <span className="close-text">Back</span>
            </button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}

      {/* Background Decorations */}
      <div className="gallery-decoration gallery-deco-1"></div>
      <div className="gallery-decoration gallery-deco-2"></div>
    </div>
  );
}

export default Gallery;
